import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The old "AC Card Zones" placeholder. Zones are now access codes (kind ZONE),
 * so the address survives as a redirect for bookmarks and old links.
 */
export const Route = createFileRoute("/_app/settings/ac-card-zones")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/zone-access", search: { tab: "codes", kind: "ZONE" }, replace: true });
	},
});
